/* eslint-disable @typescript-eslint/no-explicit-any */
import type { JSX } from 'react';
import { useEffect } from 'react';

import { getIn } from 'formik';

import { withAPIService } from '../../networking';
import { withStore } from '../../store';
import { getCardAndAttributeByName } from '../../utils/addressHelpers';
import SelectDropDown from '../Select';

interface StateSelectProps {
  name: string;
  store: any;
  apiService: any;
  dispatch: (action: any) => any;
  [key: string]: any;
}

const StateSelect = (props: StateSelectProps): JSX.Element => {
  const { name, store, apiService, dispatch } = props;

  const { cardId, index = 0 } = getCardAndAttributeByName(name);

  const { odata } = store;

  const numericIndex = Number(index) || 0;
  const shipToIndex = numericIndex > 0 ? numericIndex : 0;

  const stateData =
    cardId === 'shipTo'
      ? odata.shipTo?.[shipToIndex]
      : odata[cardId];

  const { stateList: options = [] } = stateData || {};

  const value = getIn(store.customer, name);

  useEffect(() => {
    if (value && options.length === 0) {
      const countryPath = name.substring(
        0,
        name.lastIndexOf('.')
      );
      const countryValue = getIn(
        store.customer,
        `${countryPath}.country`
      );

      apiService.getOdataList(
        dispatch,
        cardId,
        shipToIndex,
        countryValue
      );
    }
  }, [
    apiService,
    cardId,
    dispatch,
    shipToIndex,
    name,
    store.customer,
    value,
    options.length
  ]);

  return (
    <SelectDropDown
      data-testid="select"
      useValueProp
      {...props}
      value={value}
      options={options}
    />
  );
};

const connectAPI = withAPIService(StateSelect);

export default withStore(connectAPI);